import { type FC } from 'react';

import { formatBytes, toHHMMSS } from '../../utils/formatting';
import { MetaInfoWrapper, StyledDivider, StyledNotClickableTitle } from '../AdGalleryTable/styled';

//TODO: fix graphQL types
type Props = {
  format?: string;
  size?: number | null;
  duration?: number;
  fontSize?: number;
  className?: string;
};

const AdMetaInfoWrapper: FC<Props> = ({
  format,
  duration,
  size,
  fontSize = 16,
  className = 'adMetaInfoWrapper',
}): JSX.Element => (
  <MetaInfoWrapper className={className}>
    <StyledNotClickableTitle $fontSize={fontSize} data-testid="elementFormat">
      .{format}
    </StyledNotClickableTitle>
    <StyledDivider />
    <StyledNotClickableTitle $fontSize={fontSize} data-testid="elementSize">
      {formatBytes(size || 0)}
    </StyledNotClickableTitle>
    <StyledDivider />
    <StyledNotClickableTitle $fontSize={fontSize} data-testid="elementDuration">
      {toHHMMSS(duration || 0)}
    </StyledNotClickableTitle>
  </MetaInfoWrapper>
);

export default AdMetaInfoWrapper;
